type SVGWrapperProperties = React.SVGProps<SVGSVGElement>;

const withAntIconWrapper = (SvgComponent: React.FunctionComponent<SVGWrapperProperties>) => {
  return (props: SVGWrapperProperties) => (
    <span className="anticon">
      <SvgComponent {...props} />
    </span>
  );
};

export default withAntIconWrapper;
